import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function EmailMarketingRaw() {
  const [copied, setCopied] = useState(false);

  const generateEmailTemplate = () => {
    return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>QBOVerifier - Protect Your Business From Invoice Fraud</title>
  <!--[if mso]>
  <noscript>
    <xml>
      <o:OfficeDocumentSettings>
        <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
    </xml>
  </noscript>
  <![endif]-->
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; background-color: #f3f4f6;">
  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #f3f4f6;">
    <tr>
      <td align="center" style="padding: 40px 20px;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="950" style="max-width: 950px; background-color: #ffffff;">
          
          <!-- Hero Section -->
          <tr>
            <td style="position: relative; background-image: url('https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20digital%20shield%20protecting%20business%20data%20with%20blue%20technology%20network%20connections%20and%20secure%20encryption%20symbols%20in%20a%20professional%20corporate%20environment%20showing%20data%20protection%20and%20fraud%20prevention%20technology&width=950&height=500&seq=hero-email-fraud&orientation=landscape'); background-size: cover; background-position: center; padding: 80px 60px; text-align: center;">
              <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.5));"></div>
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td style="position: relative; z-index: 1;">
                    <h1 style="margin: 0 0 24px 0; font-size: 48px; font-weight: 800; color: #ffffff; line-height: 1.2;">
                      Protect Your<br>Business Reputation<br>From Scam Invoices
                    </h1>
                    <p style="margin: 0 0 32px 0; font-size: 20px; color: #e5e7eb; line-height: 1.6; max-width: 700px; margin-left: auto; margin-right: auto;">
                      Protect your business reputation and prevent fraud with QBOVerifier. "Digitally Stamp" every invoice with a unique cryptographic verification code that proves authenticity and builds client trust.
                    </p>
                    <a href="https://qboverifier.com/pricing" style="display: inline-block; background-color: #14B8A6; color: #ffffff; padding: 16px 32px; text-decoration: none; border-radius: 8px; font-weight: 600; font-size: 18px;">
                      Start Free Trial
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Growing Threat Section -->
          <tr>
            <td style="background-color: #F8F4EF; padding: 80px 60px;">
              <h2 style="margin: 0 0 16px 0; font-size: 36px; font-weight: 700; color: #1f2937; text-align: center;">
                The Growing Threat of Invoice Fraud
              </h2>
              <p style="margin: 0 0 48px 0; font-size: 18px; color: #6b7280; text-align: center; max-width: 700px; margin-left: auto; margin-right: auto;">
                Business Email Compromise (BEC) and Business Invoice Fraud (BIF) are costing companies billions annually
              </p>
              
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td width="33.33%" style="padding: 0 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-left: 4px solid #EF4444;">
                      <tr>
                        <td style="padding: 24px;">
                          <div style="width: 48px; height: 48px; background-color: #FEE2E2; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                            <span style="color: #DC2626; font-size: 24px;">⚠️</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 20px; font-weight: 600; color: #1f2937;">
                            Business Email Compromise
                          </h3>
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            Criminals impersonate executives or vendors to trick employees into sending payments to fraudulent accounts
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="33.33%" style="padding: 0 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-left: 4px solid #F59E0B;">
                      <tr>
                        <td style="padding: 24px;">
                          <div style="width: 48px; height: 48px; background-color: #FEF3C7; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                            <span style="color: #D97706; font-size: 24px;">📄</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 20px; font-weight: 600; color: #1f2937;">
                            Fake Invoice Scams
                          </h3>
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            Fraudsters send convincing fake invoices that look identical to legitimate ones, stealing millions from unsuspecting businesses
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="33.33%" style="padding: 0 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-left: 4px solid #8B5CF6;">
                      <tr>
                        <td style="padding: 24px;">
                          <div style="width: 48px; height: 48px; background-color: #EDE9FE; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                            <span style="color: #7C3AED; font-size: 24px;">💰</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 20px; font-weight: 600; color: #1f2937;">
                            Reputation Damage
                          </h3>
                          <p style="margin: 0; font-size: 14px; color: #6b7280; line-height: 1.6;">
                            Beyond financial loss, invoice fraud damages your business reputation and erodes client trust that takes years to rebuild
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Solution Section -->
          <tr>
            <td style="padding: 80px 60px;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="padding-right: 40px; vertical-align: top;">
                    <h2 style="margin: 0 0 24px 0; font-size: 36px; font-weight: 700; color: #1f2937; line-height: 1.2;">
                      The Solution: Cryptographic Invoice Verification
                    </h2>
                    <p style="margin: 0 0 32px 0; font-size: 16px; color: #6b7280; line-height: 1.6;">
                      QBOVerifier adds a unique, tamper-proof verification code to every invoice you send. Your clients can instantly verify authenticity with a simple click.
                    </p>
                    
                    <div style="margin-bottom: 20px;">
                      <div style="display: flex; align-items: flex-start; margin-bottom: 16px;">
                        <span style="color: #10B981; font-size: 24px; margin-right: 12px;">✓</span>
                        <div>
                          <h4 style="margin: 0 0 4px 0; font-size: 18px; font-weight: 600; color: #1f2937;">Instant Fraud Prevention</h4>
                          <p style="margin: 0; font-size: 14px; color: #6b7280;">Stop scammers before they can steal from your clients</p>
                        </div>
                      </div>
                      <div style="display: flex; align-items: flex-start; margin-bottom: 16px;">
                        <span style="color: #10B981; font-size: 24px; margin-right: 12px;">✓</span>
                        <div>
                          <h4 style="margin: 0 0 4px 0; font-size: 18px; font-weight: 600; color: #1f2937;">Build Client Trust</h4>
                          <p style="margin: 0; font-size: 14px; color: #6b7280;">Show clients you take their security seriously</p>
                        </div>
                      </div>
                      <div style="display: flex; align-items: flex-start; margin-bottom: 16px;">
                        <span style="color: #10B981; font-size: 24px; margin-right: 12px;">✓</span>
                        <div>
                          <h4 style="margin: 0 0 4px 0; font-size: 18px; font-weight: 600; color: #1f2937;">Select Fraud Prevention</h4>
                          <p style="margin: 0; font-size: 14px; color: #6b7280;">Choose which invoices to protect with verification codes</p>
                        </div>
                      </div>
                      <div style="display: flex; align-items: flex-start;">
                        <span style="color: #10B981; font-size: 24px; margin-right: 12px;">✓</span>
                        <div>
                          <h4 style="margin: 0 0 4px 0; font-size: 18px; font-weight: 600; color: #1f2937;">Professionally Styled Invoices</h4>
                          <p style="margin: 0; font-size: 14px; color: #6b7280;">Use our Professional styled invoice layouts, where you can add your own header graphics. Or create your own styling using our Invoice Styler.</p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td width="50%" style="vertical-align: top;">
                    <img src="https://readdy.ai/api/search-image?query=Professional%20business%20invoice%20document%20with%20green%20verified%20checkmark%20stamp%20and%20security%20badge%20showing%20cryptographic%20verification%20code%20on%20clean%20white%20background%20representing%20authenticated%20and%20fraud-proof%20billing&width=450&height=500&seq=verified-invoice-email&orientation=portrait" alt="Verified Invoice" style="width: 100%; height: auto; border-radius: 12px; box-shadow: 0 10px 25px rgba(0,0,0,0.15);">
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Features Grid -->
          <tr>
            <td style="background-color: #E6F5FD; padding: 80px 60px;">
              <h2 style="margin: 0 0 48px 0; font-size: 36px; font-weight: 700; color: #1f2937; text-align: center;">
                Key Features
              </h2>
              
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="padding: 0 12px 24px 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; padding: 32px;">
                      <tr>
                        <td>
                          <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #14B8A6, #0D9488); border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                            <span style="color: #ffffff; font-size: 28px;">🔒</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                            Cryptographic Security
                          </h3>
                          <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                            Military-grade encryption ensures your verification codes cannot be forged or duplicated
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="50%" style="padding: 0 12px 24px 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; padding: 32px;">
                      <tr>
                        <td>
                          <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #3B82F6, #2563EB); border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                            <span style="color: #ffffff; font-size: 28px;">⚡</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                            One-Click Verification
                          </h3>
                          <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                            Clients verify invoice authenticity instantly with a simple click - no technical knowledge required
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td width="50%" style="padding: 0 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; padding: 32px;">
                      <tr>
                        <td>
                          <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #8B5CF6, #7C3AED); border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                            <span style="color: #ffffff; font-size: 28px;">📊</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                            QuickBooks Integration
                          </h3>
                          <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                            Seamlessly integrates with QuickBooks Online - no disruption to your existing workflow
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="50%" style="padding: 0 12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 12px; padding: 32px;">
                      <tr>
                        <td>
                          <div style="width: 56px; height: 56px; background: linear-gradient(135deg, #F59E0B, #D97706); border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
                            <span style="color: #ffffff; font-size: 28px;">📈</span>
                          </div>
                          <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                            Verification Analytics
                          </h3>
                          <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                            Track which invoices are verified and monitor client engagement with your security measures
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- How It Works -->
          <tr>
            <td style="padding: 80px 60px;">
              <h2 style="margin: 0 0 16px 0; font-size: 36px; font-weight: 700; color: #1f2937; text-align: center;">
                How It Works
              </h2>
              <p style="margin: 0 0 48px 0; font-size: 18px; color: #6b7280; text-align: center;">
                Three simple steps to protect your business
              </p>
              
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td width="33.33%" style="padding: 0 20px; text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, #14B8A6, #0D9488); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 24px;">
                      <span style="color: #ffffff; font-size: 36px; font-weight: 700;">1</span>
                    </div>
                    <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                      Install Extension
                    </h3>
                    <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                      Add QBOVerifier to your Chrome browser in seconds
                    </p>
                  </td>
                  <td width="33.33%" style="padding: 0 20px; text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, #3B82F6, #2563EB); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 24px;">
                      <span style="color: #ffffff; font-size: 36px; font-weight: 700;">2</span>
                    </div>
                    <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                      Send Invoices
                    </h3>
                    <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                      Create invoices in QuickBooks as usual - verification codes are added automatically
                    </p>
                  </td>
                  <td width="33.33%" style="padding: 0 20px; text-align: center;">
                    <div style="width: 80px; height: 80px; background: linear-gradient(135deg, #10B981, #059669); border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 24px;">
                      <span style="color: #ffffff; font-size: 36px; font-weight: 700;">3</span>
                    </div>
                    <h3 style="margin: 0 0 12px 0; font-size: 22px; font-weight: 600; color: #1f2937;">
                      Clients Verify
                    </h3>
                    <p style="margin: 0; font-size: 15px; color: #6b7280; line-height: 1.6;">
                      Your clients click the verification link to confirm invoice authenticity
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- FREE Plan Highlight -->
          <tr>
            <td style="background: linear-gradient(135deg, #3B82F6, #2563EB); padding: 60px;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td style="text-align: center;">
                    <div style="display: inline-block; background-color: rgba(255,255,255,0.2); padding: 8px 16px; border-radius: 20px; margin-bottom: 16px;">
                      <span style="color: #ffffff; font-size: 14px; font-weight: 600;">LIMITED TIME OFFER</span>
                    </div>
                    <h2 style="margin: 0 0 16px 0; font-size: 42px; font-weight: 800; color: #ffffff;">
                      Start FREE Today
                    </h2>
                    <p style="margin: 0 0 32px 0; font-size: 20px; color: rgba(255,255,255,0.9); max-width: 600px; margin-left: auto; margin-right: auto;">
                      Protect up to 5 invoices per month at no cost. No credit card required.
                    </p>
                    <a href="https://qboverifier.com/pricing" style="display: inline-block; background-color: #ffffff; color: #2563EB; padding: 18px 40px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 18px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                      Get Started Free
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Benefits Section -->
          <tr>
            <td style="background-color: #F8F4EF; padding: 80px 60px;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                <tr>
                  <td width="50%" style="padding-right: 40px; vertical-align: top;">
                    <h3 style="margin: 0 0 24px 0; font-size: 28px; font-weight: 700; color: #1f2937;">
                      For Invoice Senders
                    </h3>
                    <ul style="margin: 0; padding: 0; list-style: none;">
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Protect your business reputation from fraud</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Build trust with clients through verified invoices</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Reduce payment disputes and delays</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Stand out from competitors with advanced security</span>
                      </li>
                    </ul>
                  </td>
                  <td width="50%" style="padding-left: 40px; vertical-align: top;">
                    <h3 style="margin: 0 0 24px 0; font-size: 28px; font-weight: 700; color: #1f2937;">
                      For Invoice Receivers
                    </h3>
                    <ul style="margin: 0; padding: 0; list-style: none;">
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Instantly verify invoice authenticity</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Protect your company from BEC and BIF scams</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">Pay with confidence knowing invoices are legitimate</span>
                      </li>
                      <li style="margin-bottom: 16px; padding-left: 32px; position: relative;">
                        <span style="position: absolute; left: 0; color: #14B8A6; font-size: 20px;">✓</span>
                        <span style="font-size: 15px; color: #4b5563;">No software installation required</span>
                      </li>
                    </ul>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Testimonial -->
          <tr>
            <td style="padding: 80px 60px;">
              <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background: linear-gradient(135deg, #F3F4F6, #E5E7EB); border-radius: 16px; padding: 48px;">
                <tr>
                  <td style="text-align: center;">
                    <div style="margin-bottom: 16px;">
                      <span style="color: #F59E0B; font-size: 24px;">★★★★★</span>
                    </div>
                    <p style="margin: 0 0 24px 0; font-size: 20px; font-style: italic; color: #1f2937; line-height: 1.6; max-width: 700px; margin-left: auto; margin-right: auto;">
                      "QBOVerifier has been a game-changer for our business. Our clients love the added security, and we've seen a significant reduction in payment disputes. It's an essential tool for any business serious about protecting their reputation."
                    </p>
                    <p style="margin: 0; font-size: 16px; font-weight: 600; color: #4b5563;">
                      Sarah Johnson, CFO
                    </p>
                    <p style="margin: 0; font-size: 14px; color: #6b7280;">
                      TechCorp Solutions
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Final CTA -->
          <tr>
            <td style="background-color: #1f2937; padding: 80px 60px; text-align: center;">
              <h2 style="margin: 0 0 16px 0; font-size: 36px; font-weight: 700; color: #ffffff;">
                Ready to Protect Your Business?
              </h2>
              <p style="margin: 0 0 32px 0; font-size: 18px; color: #d1d5db;">
                Join hundreds of businesses already using QBOVerifier
              </p>
              <a href="https://qboverifier.com/pricing" style="display: inline-block; background-color: #14B8A6; color: #ffffff; padding: 18px 40px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 18px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                Start Free Trial
              </a>
              <a href="https://qboverifier.com/how-it-works" style="display: inline-block; background-color: transparent; color: #ffffff; padding: 18px 40px; text-decoration: none; border-radius: 8px; font-weight: 700; font-size: 18px; border: 2px solid #ffffff;">
                Learn More
              </a>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #111827; padding: 40px 60px; text-align: center;">
              <p style="margin: 0 0 16px 0; font-size: 14px; color: #9ca3af;">
                © 2024 QBOVerifier. All rights reserved.
              </p>
              <p style="margin: 0; font-size: 14px;">
                <a href="https://qboverifier.com/privacy-policy" style="color: #14B8A6; text-decoration: none; margin: 0 12px;">Privacy Policy</a>
                <a href="https://qboverifier.com/terms-of-service" style="color: #14B8A6; text-decoration: none; margin: 0 12px;">Terms of Service</a>
                <a href="https://qboverifier.com/contact" style="color: #14B8A6; text-decoration: none; margin: 0 12px;">Contact Us</a>
              </p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
  };

  const handleCopyToClipboard = () => {
    const htmlCode = generateEmailTemplate();
    navigator.clipboard.writeText(htmlCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                <i className="ri-code-s-slash-line text-teal-600 mr-2"></i>
                Raw HTML Email Template
              </h1>
              <p className="text-gray-600">
                Copy the HTML code below and paste it into your email marketing platform
              </p>
            </div>
            <button
              onClick={handleCopyToClipboard}
              className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors flex items-center gap-2 whitespace-nowrap"
            >
              {copied ? (
                <>
                  <i className="ri-check-line text-xl"></i>
                  Copied!
                </>
              ) : (
                <>
                  <i className="ri-file-copy-line text-xl"></i>
                  Copy to Clipboard
                </>
              )}
            </button>
          </div>

          {copied && (
            <div className="mb-4 p-4 bg-green-100 text-green-800 rounded-lg border border-green-200">
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <span className="font-semibold">HTML code copied to clipboard!</span>
              </div>
            </div>
          )}

          <div className="bg-gray-900 rounded-lg p-6 overflow-x-auto">
            <pre className="text-sm text-green-400 font-mono whitespace-pre-wrap break-words">
              <code>{generateEmailTemplate()}</code>
            </pre>
          </div>

          <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <h3 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
              <i className="ri-information-line text-blue-600"></i>
              How to use this code:
            </h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">1.</span>
                <span>Click "Copy to Clipboard" button above</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">2.</span>
                <span>Open your email marketing platform (Mailchimp, SendGrid, Constant Contact, etc.)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">3.</span>
                <span>Create a new campaign and select "Custom HTML" or "Code Editor"</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">4.</span>
                <span>Paste the HTML code into the editor</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-blue-600 mt-1">5.</span>
                <span>Preview and test your email before sending</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
